import { useState, useEffect, useId } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useUnreadMessages = (profileId: string | undefined) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const instanceId = useId();

  useEffect(() => {
    if (!profileId) { setUnreadCount(0); return; }

    let convoIds: string[] = [];

    const fetchUnread = async () => {
      const { data: convos } = await supabase
        .from("conversations")
        .select("id")
        .or(`humano_id.eq.${profileId},compawdre_id.eq.${profileId}`);

      if (!convos || convos.length === 0) { setUnreadCount(0); return; }

      convoIds = convos.map((c) => c.id);
      const { count } = await supabase
        .from("chat_messages")
        .select("id", { count: "exact", head: true })
        .in("conversation_id", convoIds)
        .neq("sender_id", profileId)
        .is("read_at", null);

      setUnreadCount(count || 0);
    };

    fetchUnread();

    const channel = supabase
      .channel(`dashboard-unread-${profileId}-${instanceId}`)
      .on("postgres_changes", { event: "*", schema: "public", table: "chat_messages" }, () => {
        fetchUnread();
      })
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, [profileId]);

  return unreadCount;
};
